import { getServices } from '~/db/services';

type UseCategoryOthersThumbnails = {
  thumbnails: Ref<Thumbnail[]>;
  loadThumbnails: () => Promise<void>;
};

export const useCategoryOthersThumbnails = (
  ids: string[],
  libraryBookId: string,
  type: 'essential' | 'annals'
): UseCategoryOthersThumbnails => {
  const route = useRoute();
  const { $db } = useNuxtApp();
  const thumbnails = ref<Thumbnail[]>([]);

  const { categoriesService, mediasService, postsService } = getServices($db);

  // retrieve categories
  const getThumbnails = async () => {
    let items = [];
    const categories = await categoriesService.findByIdsAndLibraryBookId(
      ids,
      libraryBookId
    );
    // get first post for each cat
    categories.forEach((cat) => {
      const post = cat.children.find((child) => child.type === 'post');
      if (post) {
        items.push({ category: cat, post: post.id });
      }
    });
    // retrieve posts
    // TODO optilise query
    const posts = await postsService.findByIds(items.map((item) => item.post));

    items = items
      .map((item) => {
        const post = posts.find((p) => p.id === item.post);
        const media =
          post && post.medias && post.medias.length > 0 ? post.medias[0] : null;
        return { ...item, post, media };
      })
      .filter((item) => item.media);
    // retrieve medias
    const medias = await mediasService.findByIds(
      items.map((item) => item.media.id)
    );

    const thumbnails: Thumbnail[] = items
      .map((item) => {
        const media = medias.find((md) => md.id === item.media.id);

        if (media) {
          const title =
            type === 'annals' ? item.category.title : item.post.title;
          const contentId = item.category.id;

          return {
            title,
            contentId,
            imgSrc: media.appThumbnailUrl,
            to: `${route.path}#/modal/${item.category.slug}`,
            type,
          };
        } else {
          return null;
        }
      })
      .filter((item) => item);

    return thumbnails;
  };

  const getThumbnailsTransaction = async () => {
    return await $db.transaction(
      'r',
      $db.categories,
      $db.posts,
      $db.media,
      async () => {
        return await getThumbnails();
      }
    );
  };

  const loadThumbnails = async () => {
    try {
      const thumbs = await getThumbnailsTransaction();
      thumbnails.value = thumbs;
    } catch (e) {
      globalThis.$logger.error(
        'useCategoryOthersThumbnails :: loadThumbnails :',
        e
      );
    }
  };

  return {
    thumbnails,
    loadThumbnails,
  };
};
